import { render, staticRenderFns } from "./BulkList.vue?vue&type=template&id=96c1f646"
import script from "./BulkList.vue?vue&type=script&lang=js"
export * from "./BulkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports